const store = {
    namespaced: true,
    state() {
        return {
            categories: []
        };
    },
    getters: {
        getCategories: state => state.categories
    },
    mutations: {
        SET_CATEGORIES: (state, data) => (state.categories = data)
    },
    actions: {
        fetchCategories: async function ({ commit }) {
            try {
                const { data } = await this.$api.home.getCategories();
                commit('SET_CATEGORIES', data);
            } catch (e) {
                console.error(e);
            }
        }
    }
};

export default store;
